import React from 'react';
import { Play, Youtube, Eye, Clock } from 'lucide-react';
import { ytHighlights as fallbackHighlights, streamer } from '../mock';
import { useHighlights } from '../hooks/useHighlights';

export default function YouTubeHighlights({ onPlay }) {
  const { items, loading } = useHighlights();
  const highlights = items.length > 0 ? items : (loading ? [] : fallbackHighlights);

  if (!loading && highlights.length === 0) return null;
  return (
    <section id="youtube" className="relative py-24 px-6 lg:px-10 bg-zinc-950/80 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 text-red-400 text-sm font-semibold mb-2">
              <Youtube className="w-4 h-4" /> YOUTUBE HIGHLIGHTS
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white tracking-tight">
              Te lui voor de hele stream?
            </h2>
            <p className="text-zinc-400 mt-3 max-w-xl">
              Korte samenvattingen en de beste momenten. Speelt direct af in een mini-player.
            </p>
          </div>
          <a
            href={streamer.socials.youtube}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-white/5 hover:bg-white/10 border border-white/10 text-white font-semibold transition-colors"
          >
            <Youtube className="w-4 h-4 text-red-400" /> Open YouTube kanaal
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {highlights.map((y, idx) => (
            <button
              key={y.id}
              onClick={() => onPlay({ ...y, title: y.title })}
              className={`group relative text-left rounded-2xl overflow-hidden border border-white/10 hover:border-violet-500/40 transition-all hover:-translate-y-1 ${
                idx === 0 ? 'md:col-span-1' : ''
              }`}
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={y.thumb}
                  alt={y.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-16 h-16 rounded-full bg-red-600 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg shadow-red-900/40">
                    <Play className="w-7 h-7 text-white fill-current ml-1" />
                  </span>
                </div>
                {y.duration && (
                  <div className="absolute bottom-2 right-2 flex items-center gap-1 px-2 py-1 rounded bg-black/70 backdrop-blur text-xs text-white font-mono">
                    <Clock className="w-3 h-3" /> {y.duration}
                  </div>
                )}
              </div>
              <div className="p-4 bg-white/[0.02]">
                <h3 className="text-white font-semibold leading-snug line-clamp-2 group-hover:text-violet-300 transition-colors">
                  {y.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-zinc-500 mt-2">
                  <Eye className="w-3 h-3" /> {y.views || 'YouTube'}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
